import axios from 'axios';

let prefix = "/recycling-history"

const RecyclingHistoryApi = {
	
	getRecyclingHistoryList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getRecyclingHistoryListVendor(payload){
		return axios.get( prefix + "/list-vendor", {params: payload})
	},
	getRecyclingHistoryById(id, payload){
		return axios.get( prefix + "/get/" + id, { params: payload })
	},
	createRecyclingHistory(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateRecyclingHistory(payload){
		return axios.post( prefix + "/update", payload)
	},
	uploadPaymentReceipt(payload){
		return axios.post( prefix + "/upload-payment-receipt", payload)
	},
	uploadCollectionReceipt(payload){
		return axios.post( prefix + "/upload-collection-receipt", payload)
	},
	uploadProofImage(payload){
		return axios.post( prefix + "/upload-proof-image", payload)
	},
	// updateProductionStatus(payload){
	// 	return axios.post( prefix + "/update-production-status", payload)
	// },
	updateValidationStatus(payload){
		return axios.post( prefix + "/update-validation-status", payload)
	},
	deleteRecyclingHistory(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	async exportBuybackList(payload){
		try {
			return await axios.get( prefix + "/export-recycling-history", { params: payload, responseType: 'blob' })
		} catch (err) {
			// interceptor rejects with error.response; error body arrives as a Blob under responseType 'blob'
			if (err && err.data instanceof Blob) {
				try { err.data = JSON.parse(await err.data.text()) } catch (e) { /* leave as-is */ }
			}
			return Promise.reject(err)
		}
	},
	updateTransactionDetails(payload){
		return axios.post( prefix + "/update-transaction-details", payload)
	},
	// Moves waste lines between the waste and recyclable weight buckets. Weight only —
	// it never touches points, cash, carbon or the customer's balance.
	reclassifyWaste(payload){
		return axios.post( prefix + "/reclassify-waste", payload)
	},

}

export default RecyclingHistoryApi;